import styled from '@emotion/styled';
import { shouldForwardProp } from '@/utils/style.utils';
import { color } from '@tajawal/ct-web-design-system';

const AirportWrapper = styled('div', { shouldForwardProp })<{ $isReturnFlight: boolean }>`
  width: 72px;
  display: flex;
  flex-direction: column;
  align-items: ${({ $isReturnFlight }) => ($isReturnFlight ? 'flex-end' : 'flex-start')};
`;

const AirportName = styled('div', { shouldForwardProp })<{ $highlightColor: string }>`
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${({ $highlightColor }) => color($highlightColor)};
  border-radius: 4px;
  padding: 2px ${({ $highlightColor }) => ($highlightColor === 'white' ? '0' : '4px')};
`;

const AirportTooltipContent = styled.div`
  text-align: center;
`;

export default {
  AirportName,
  AirportTooltipContent,
  AirportWrapper,
};
